module.exports = __webpack_public_path__ + "static/img/harken-ban.2b83563f.jpg";